import React, { useEffect } from "react";
import { FaApple, FaGooglePlay, FaArrowRight } from "react-icons/fa";

const openInNewTab = (url) => {
  window.open(url, "_blank", "noreferrer");
};

export const Gallery = (props) => {
  const bankName = props.data?.nameBank || "CORE bank";
  const urlRegister = props.data
    ? `https://app.${props.data.nameBankDomain || "corebankdigital"}.com.br/register`
    : "/";

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: 0 }
    );

    const elements = document.querySelectorAll("#gallery .reveal");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="gallery">
      <div className="container">
        <div className="gallery-grid">
          <div className="gallery-content">
            <span className="gallery-eyebrow reveal">
              <span className="gallery-eyebrow-dot" aria-hidden="true"></span>
              Disponível para iOS e Android
            </span>
            <h2 className="reveal">
              {props.data
                ? props.data.title
                : `Baixe o app do ${bankName} e abra sua conta em poucos minutos`}
            </h2>
            <p className="gallery-paragraph reveal">
              Conta digital aberta em minutos, sem papelada e direto pelo
              celular. Pix, cartão, investimentos e crédito — tudo no seu
              bolso, com a segurança do {bankName}.
            </p>

            <div className="gallery-ctas reveal">
              <button
                type="button"
                className="btn btn-custom gallery-cta-primary"
                onClick={() => openInNewTab(urlRegister)}
                aria-label="Abrir minha conta CORE bank"
              >
                Abrir minha conta
                <FaArrowRight className="gallery-cta-icon" aria-hidden="true" />
              </button>
            </div>

            <div
              className="gallery-store-badges reveal"
              aria-label="Baixe na App Store ou Google Play"
            >
              <a
                href="#download"
                className="store-badge"
                onClick={(e) => e.preventDefault()}
                aria-label="Baixar na App Store (em breve)"
              >
                <FaApple className="store-badge-icon" aria-hidden="true" />
                <div className="store-badge-text">
                  <span className="store-badge-small">Baixe na</span>
                  <strong>App Store</strong>
                </div>
              </a>

              <a
                href="#download"
                className="store-badge"
                onClick={(e) => e.preventDefault()}
                aria-label="Disponível no Google Play (em breve)"
              >
                <FaGooglePlay
                  className="store-badge-icon"
                  aria-hidden="true"
                />
                <div className="store-badge-text">
                  <span className="store-badge-small">Disponível no</span>
                  <strong>Google Play</strong>
                </div>
              </a>
            </div>
          </div>

          <div className="gallery-phone-wrap">
            <div className="gallery-phone-halo" aria-hidden="true"></div>
            <img
              src="img/aeja-arco.png"
              className="gallery-phone reveal"
              alt={`Aplicativo ${bankName} no smartphone`}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
